var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlean(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    "data-name": "logosandtypes com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #343ced;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,0H150V150H0V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.25,13.5L99.56,1.32l-12.94,16.44c-5.84-2.7-12.37-4.22-19.24-4.22-25.21,0-45.65,20.32-45.65,45.38s20.44,45.38,45.65,45.38,45.65-20.32,45.65-45.38c0-11.07-3.98-21.22-10.61-29.09l12.83-16.32Zm-47.87,71.31c-14.38,0-26.04-11.59-26.04-25.89s11.67-25.89,26.04-25.89,26.04,11.59,26.04,25.89-11.65,25.89-26.04,25.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.56,97.74c-14.67,17.59-39.69,25.34-61.76,19.27l-5.12,19c31.77,8.74,67.49-4.04,86.31-31.13l-16.2-11.28c-1.01,1.43-2.09,2.81-3.22,4.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlean);
export default __webpack_public_path__ + "static/media/glean.1a8d64ce27bb32fceb8d54dd2f2f0827.svg";
export { ForwardRef as ReactComponent };